import { render, staticRenderFns } from "./clrmgMore.vue?vue&type=template&id=00cf4c93&scoped=true&"
import script from "./clrmgMore.vue?vue&type=script&lang=js&"
export * from "./clrmgMore.vue?vue&type=script&lang=js&"
import style0 from "./clrmgMore.vue?vue&type=style&index=0&id=00cf4c93&lang=less&scoped=true&"
import style1 from "./clrmgMore.vue?vue&type=style&index=1&id=00cf4c93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cf4c93",
  null
  
)

export default component.exports